import { useQuery } from '@tanstack/react-query'

import type { Entity } from '@models/Entity'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchLinkedProjectsForEntity } from '../services/fetchLinkedProjectsForEntity'

export { useLinkedProjectsForEntity, queryKey }

const queryKey = 'entityProjects'

const useLinkedProjectsForEntity = (entity: Entity) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data, isError, isFetching, refetch } = useQuery({
    queryKey: [queryKey, entity.id],
    queryFn: () => fetchLinkedProjectsForEntity(entity.id),
    enabled: hasPermissions && !!entity.id,
    refetchOnMount: true,
  })

  return {
    data: data || {
      count: 0,
      groups: [],
      items: [],
    },
    isError,
    isFetching,
    refetch,
  }
}
